export const getBpsAccountUrl = (token, type) => {
    const baseUrl = process.env.REACT_APP_MQ_URL
    return `${baseUrl}/create-account?redemptionToken=${token}&type=${type}`
}